var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _radialGradient, _linearGradient7, _linearGradient8, _radialGradient2, _linearGradient9, _radialGradient3, _radialGradient4, _radialGradient5, _linearGradient10, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFireemoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2317,
    stopColor: "#ff1500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7367,
    stopColor: "#ff3d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#ff4c00"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 12.9634,
    x2: 9.46041,
    xlinkHref: "#a",
    y1: 22.2512,
    y2: -3.13459
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 17.068,
    x2: 13.565,
    xlinkHref: "#a",
    y1: 21.6851,
    y2: -3.70073
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 10.7347,
    x2: 7.2317,
    xlinkHref: "#a",
    y1: 22.5587,
    y2: -2.82709
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 12.869,
    x2: 5.21432,
    y1: 17.927,
    y2: -3.9342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#ff5b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#ff4c00"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#ffed1c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#ffed1c",
    stopOpacity: 0.026478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#ffed1c",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 16.1473,
    cy: 0.135867,
    gradientUnits: "userSpaceOnUse",
    r: 10.2006,
    xlinkHref: "#f"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 9.89669,
    x2: 12.6645,
    y1: 3.33922,
    y2: 18.8648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022669,
    stopColor: "#fe7f02",
    stopOpacity: 0.9773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6663,
    stopColor: "#ed582a",
    stopOpacity: 0.3337
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e74939",
    stopOpacity: 0
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 12.046,
    x2: 12.6442,
    y1: 20.1156,
    y2: 9.21433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    stopColor: "#ffb137",
    stopOpacity: 0.8131
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7223,
    stopColor: "#ff940f",
    stopOpacity: 0.2777
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8900",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(7.89073 0 0 6.40569 11.8972 17.1739)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#ffbc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2941,
    stopColor: "#ffbf4b",
    stopOpacity: 0.7068
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#fec656",
    stopOpacity: 0.4382
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8201,
    stopColor: "#fcd368",
    stopOpacity: 0.1801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe07a",
    stopOpacity: 0
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(7.64758 0 0 6.2083 11.8972 16.8495)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#k"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(9.39451 0 0 10.938 8.54394 18.2601)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#f"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-.14957475 2.96535006 -2.40713973 -.12141815 11.8976 16.8487)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#k"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#ffed1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#ffee2b",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#fff254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff686",
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 13.5387,
    cy: 3.98335,
    gradientUnits: "userSpaceOnUse",
    r: 3.37018,
    xlinkHref: "#o"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(1.51025428 -2.27411416 .5164598 .34298437 7.98155 5.60476)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#f"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-.21623413 2.44342068 -.98315864 -.08700608 8.52218 3.46406)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#o"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 12.79,
    cy: 3.55061,
    gradientUnits: "userSpaceOnUse",
    r: 10.516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#ff4c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#ff5b0c",
    stopOpacity: 0.8661
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#ff842c",
    stopOpacity: 0.6067
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#ffc45f",
    stopOpacity: 0.2512
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff686",
    stopOpacity: 0
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 17.5729,
    cy: 12.0702,
    gradientUnits: "userSpaceOnUse",
    r: 5.58172,
    xlinkHref: "#o"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 6.147,
    cy: 14.0596,
    gradientUnits: "userSpaceOnUse",
    r: 5.9494,
    xlinkHref: "#o"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(.691327 10.16742395 -6.180739 .4202551 11.8084 12.8571)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4c00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9874,
    stopColor: "#ff4c00",
    stopOpacity: 0.9888
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#ff4c00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7484 8.12591c1.2799-2.36-1.8915-2.68571-1.8972-4.13714 0 0-.56 1.49714.7772 2.52 1.0914.82857 1.12 1.61714 1.12 1.61714z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.017 3.61133c-.48572.48.18286 2.46286-1.33714 3.24571 0 0-.51429-2.17714 1.33714-3.24571z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.45703 11.4513c-.42286.7258-1 2.0686-1 3.9715 0 2.1257 2.70857 6.0343 7.13717 6.0343 4.3257 0 7.6857-3.3315 7.6857-6.1943 0-1.0343-.2857-2.3543-.92-3.2915-.0457.5886-.1886 1.3886-.6286 1.8058-.2286.2171-.5143.3142-.8286.28l-.32-.0286.0972-.3029c.0114-.0285.84-2.7371.24-4.34283-.24.58857-.6514 1.34853-1.1543 1.38853l-.2857.0229.0057-.2857c.0229-1.18288-.7029-1.81145-1.5429-2.53716-1.2-1.04-2.5542-2.21714-2.0571-5.20572-.8343.49143-2.45714 1.84572-2.05143 4.64.20573 1.4-.28 2.44-.29714 2.48572l-.05714.11996-.12572.0229c-.24.0457-.49143-.05143-.72-.26858-.30857-.30285-.58857-.87428-.6-1.65142-.46857.48-1.11428 1.30857-1.11428 2.2514 0 1.5486.75428 3.2172.76 3.2343l.21143.4686-.50286-.1086c-1.31429-.2857-1.80571-1.5086-1.93143-2.5086z",
    fill: "url(#e)",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.8513 3.98877c-.1143.86286.2286 2.10286.7771 2.52.5029.38286 1.0686 1.04 1.1143 1.61714.8572-1.68-.3486-2.30285-1.04-2.54857-.2914-.10286-.8286-.70286-.8514-1.58857z",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11.2171 3.74316c-1.8971 2.97143.5658 6.10858-.7028 7.98854-1.26858 1.88-2.5543.1429-2.64001-1.0343 0 0 .01143 3.8058 1.89143 5.3086 1.87998 1.5029-3.61715 1.1772-4.37143-.6571 0 0 0 6.1085 6.20001 6.1085 6.2 0 7.2343-5.6857 7.2343-5.6857s-2.2572 1.9257-3.76.4229c0 0 1.1257-1.9714 1.4114-3.9943 0 0-.7771.4914-1.9714.3029 0 0 .6628-2.84004-.6915-3.77146-1.7371-1.19429-3.2057-4.04-2.6-4.98858z",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m11.6914 7.23975c-.9943 1.30857.9429 4.66855-1.0914 5.99995-1.12573.7372-1.77144-.1485-1.77144-.1485s.30286 1.36 1.51424 2.5714c1.2115 1.2114-1.82281 2.8514-4.28567.7314 0 0 .84571 5.0915 6.57717 4.2343 6.3257-.9428 5.8571-5.6457 5.8571-5.6457s-1.7143 2.6971-4.1543 1.4057c0 0 1.5372-2.1428 1.5372-3.3714 0 0-1.04.6171-2.2286.0228 0 0 .5657-2.8571-.1086-3.28567-1.6171-1.03428-1.8457-2.51428-1.8457-2.51428z",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#j)",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#l)",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m4.8457 14.0971c.13143 3.2285 2.78857 7.0971 6.9429 7.0971 4.1542 0 6.2285-4.3828 6.36-6.9486 0 0-.7772 1.5086-2.5315 1.8115-1.7543.3028.12-3.0172-1.1085-4.9829 0 0-1.0858 3.4229-2.6286 3.5486-1.5429.1257-2.85144-2.2629-2.85144-3.5486 0 0-.94857 2.3143-.71429 4.1543.36 2.7943-3.46857-1.1314-3.46857-1.1314z",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#n)",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7484 8.12591c1.2799-2.36-1.8915-2.68571-1.8972-4.13714 0 0-.56 1.49714.7772 2.52 1.0914.82857 1.12 1.61714 1.12 1.61714z",
    fill: "url(#p)",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m9.017 3.61133c-.48.48-.17143 1.99428-1.33714 3.24571 0 0-.51429-2.17714 1.33714-3.24571z",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m9.017 3.61133c-.48572.48.18286 2.46286-1.33714 3.24571 0 0-.51429-2.17714 1.33714-3.24571z",
    fill: "url(#r)",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#s)",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#t)",
    opacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#u)",
    opacity: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7427 10.5085c.0629-3.16-4.7371-2.72571-3.5028-8.22286 0 0-3.22287 1.26858-2.65715 5.16.19428 1.33715-.27429 2.33715-.27429 2.33715-.47428.09714-1.21143-.84572-.95429-2.30286 0 0-1.69142 1.26286-1.69142 2.88567 0 1.6229.78285 3.3429.78285 3.3429-1.94857-.4229-1.75428-3.0514-1.75428-3.0514s-1.23429 1.6514-1.23429 4.7657c0 2.4228 2.73143 6.2914 7.13717 6.2914 4.4057 0 7.9428-3.4171 7.9428-6.4571 0-1.3315-.4514-3.0515-1.4285-3.9886 0 0 .1314 2.6571-1.1829 2.5314 0 0 1.0857-3.4685-.0514-5.05711 0 0-.5486 1.71431-1.1315 1.76571z",
    fill: "url(#v)",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireemoji);
export default __webpack_public_path__ + "static/media/Fireemoji.7bb8943eb2d4bfafee3fbaa285e7721b.svg";
export { ForwardRef as ReactComponent };